import { render, staticRenderFns } from "./shopClosedDays.vue?vue&type=template&id=4c6bd35e&scoped=true"
import script from "./shopClosedDays.vue?vue&type=script&lang=js"
export * from "./shopClosedDays.vue?vue&type=script&lang=js"
import style0 from "./shopClosedDays.vue?vue&type=style&index=0&id=4c6bd35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6bd35e",
  null
  
)

export default component.exports